export default __webpack_public_path__ + "static/media/scala.6d2d860a.png";